import { cn } from "./utils";

export function Wordmark({ className, suffix = "API" }: { className?: string; suffix?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-1.5 text-[15px] font-semibold tracking-title text-ink", className)}>
      <svg viewBox="0 0 16 16" className="size-4" aria-hidden>
        <rect x="1" y="1" width="14" height="14" rx="4" fill="var(--ink)" />
        <rect x="5" y="5" width="6" height="6" rx="1.5" fill="var(--canvas)" />
      </svg>
      moan.hot
      <span className="font-mono text-xs font-normal text-ink-3">{suffix}</span>
    </span>
  );
}
